import { toNumber } from './toNumber';

export const groupItemsByTable = (items, sectionRule, defaultLaborRate) => {
  const groups = [];
  let current = { items: [], subtotal: 0 };

  items
    .filter(i => i.show_mpi && i.active && !i.deleted)
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .forEach(item => {
      if (item.layout_type === 'new_table_with_subtotal') {
        if (current.items.length) {
          current.subtotal = calculateSubtotal(current.items, sectionRule, defaultLaborRate);
          groups.push(current);
        }
        current = { title: item.description || 'New Section', items: [], subtotal: 0 };
      } else {
        current.items.push(item);
      }
    });

  if (current.items.length) {
    current.subtotal = calculateSubtotal(current.items, sectionRule, defaultLaborRate);
    groups.push(current);
  }

  return groups;
};

export const calculateSubtotal = (items, rule = {}, defaultLaborRate) => {
  if (!rule.subtotal) return 0;
  const equation = rule.equation || 'estimate_total';

  return items.reduce((sum, item) => {
    const value = calculateValue(item, equation, defaultLaborRate);
    return sum + (item.approved || item.recommend || item.required ? value : 0);
  }, 0);
};

const calculateValue = (item, equation, defaultLaborRate) => {
  if (!equation) return 0;

  const vals = {
    estimate_total: toNumber(item.estimate_total),
    labor_total: toNumber(item.labor_total),
    parts_total: toNumber(item.parts_total),
    labor_hours: toNumber(item.labor_hours),
    labor_rate: toNumber(item.labor_rate || defaultLaborRate),
    quantity: toNumber(item.quantity || 1),
    parts: toNumber(item.parts),
  };

  if (equation.includes('*')) {
    const [a, b] = equation.split('*').map(s => s.trim());
    return vals[a] * vals[b];
  }

  return vals[equation] !== undefined ? vals[equation] : (toNumber(item[equation]) || 0);
};